import Typography from "@mui/material/Typography";
import type { TaskListPublication } from "./useTaskListSubscription";

export function PublicationSuccessRate(props: { publication: TaskListPublication; phaseStatus: string }) {
  const { totalItems, publishedItems } = props.publication;
  const successShare = (publishedItems / totalItems) * 100;
  const successRate = totalItems > 0 ? Math.round(successShare) : 0;
  const isCompleted = props.phaseStatus === "completed";
  const isFullSuccess = publishedItems === totalItems;
  const outcomeColor = isFullSuccess ? "success.main" : "error.main";
  const color = isCompleted ? outcomeColor : "text.secondary";
  return (
    <Typography
      component="span"
      variant="caption"
      sx={{ ml: 1, color, fontWeight: 500 }}
    >
      {publishedItems}/{totalItems} · {successRate}%
    </Typography>
  );
}
